// extracted by mini-css-extract-plugin
export var modalContent = "styles-module--modalContent--1-wLb";
export var modalHeader = "styles-module--modalHeader--Dq-Ho";
export var closeIcon = "styles-module--closeIcon--3RUXb";
export var link = "styles-module--link--3HtYW";